import React, { useEffect, useState } from 'react'

import { Separator } from 'shared/components'
import { useIntersection, useWindowSize } from 'shared/hooks'

import { Cooperation, HowItWork, Subscribers, WhoPartner } from './common'
import classes from './Partners.module.scss'

export const Partners = (): JSX.Element => {
  const [ref, entery] = useIntersection({ threshold: 0.1 })
  const [className, setClassName] = useState('')
  const { isLargeDesktop, isDesktop } = useWindowSize()

  useEffect(() => {
    const name =
      (isLargeDesktop || isDesktop) && entery?.isIntersecting
        ? classes.full
        : ''
    if (name !== className) {
      setClassName(name)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entery, isLargeDesktop, isDesktop])

  return (
    <div ref={ref} className={`${classes.wrapper} container ${className}`}>
      <WhoPartner />
      <Separator className={classes.separator} />
      <HowItWork />
      <Separator height={50} />
      <Subscribers />
      <Cooperation />
    </div>
  )
}
